import axiosInstance from 'services/axiosInstance';
import {
  ICheckIfTicketHasChannelParams,
  ICheckIfTicketHasChannelResponse, ICheckIfTicketHasSomeChannelsParams,
  ICreateSmsChannelPayload,
  ICreateSmsChannelResponse,
  IMessageTemplate,
  ISendSmsMessagePayload,
  ISmsChannel,
  ISmsChannelHistory,
  ISMSConfiguration,
  ITicketChat,
} from 'services/smsConversations/types';
import { IResponse } from 'services/types';
import { LabelValue } from '../common/types';

export const checkIfTicketHasSmsChannel = (
  params: ICheckIfTicketHasChannelParams,
): IResponse<ICheckIfTicketHasChannelResponse> =>
  axiosInstance.request({
    method: 'GET',
    url: '/MessagingBoard/checkTicketChannels',
    params,
  });

export const checkIfTicketHasSomeSmsChannels = (
  params: ICheckIfTicketHasChannelParams,
): IResponse<ICheckIfTicketHasSomeChannelsParams> =>
  axiosInstance.request({
    method: 'GET',
    url: '/MessagingBoard/checkTicketChannels/v2',
    params,
  });

export const getSmsConfiguration = (configId: number): IResponse<ISMSConfiguration> =>
  axiosInstance.request({
    method: 'GET',
    url: `/MessagingConfigurations/${configId}`,
  });

export const getSmsConfigurations = (): IResponse<ISMSConfiguration[]> =>
  axiosInstance.request({
    method: 'GET',
    url: '/MessagingConfigurations',
  });

export const getSmsChannel = (channelId: number): IResponse<ISmsChannel> =>
  axiosInstance.request({ method: 'GET', url: `/MessagingBoard/channels/${channelId}` });

export const getChannelHistory = (
  channelId: number,
  orderDesc: boolean = false,
): IResponse<ISmsChannelHistory[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/MessagingBoard/channels/${channelId}/channelHistory`,
    params: {
      userOnly: false,
      orderDesc,
    },
  });

export const sendSmsChannelMessage = (
  channelId: number,
  payload: ISendSmsMessagePayload,
): IResponse<ISmsChannelHistory> =>
  axiosInstance.request({
    method: 'POST',
    url: `/MessagingBoard/channels/${channelId}/send`,
    data: payload,
  });

export const createSmsChannel = (
  crmId: number,
  payload: ICreateSmsChannelPayload,
): IResponse<ICreateSmsChannelResponse> =>
  axiosInstance.request({
    method: 'POST',
    url: `/TicketUpdate/crm/${crmId}/tickets/createChannel/v2`,
    data: payload,
  });

export const getMessageTemplates = (channelId?: number | undefined): IResponse<IMessageTemplate[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `/SmsConversations${channelId ? `?channelId=${channelId}` : ''}`,
  });

export const getSmsTextTemplateVariables = (): IResponse<LabelValue[]> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SmsConversations/smsTextTemplateVariables',
  });

export const getTicketChats = (crmId: number, ticketId: string): IResponse<ITicketChat[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `MessagingBoard/${crmId}/allTicketChannels?ticketId=${ticketId}`,
  });
